import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup'
import * as Yup from 'yup'

const RegistarInteracao = (props) => {
    const formSchema = Yup.object().shape({
        comentario: Yup.string().required('O comentário é obrigatório.')
    });

    const formOptions = { resolver: yupResolver(formSchema), mode:"onChange" }

    const { register, handleSubmit, formState: { errors, isValid } } = useForm(formOptions);
    const [cancelTicket, setCancelTicket] = useState(false)
    const [disagreed, setDisagreed] = useState(false);
    const isButtonEnabled = isValid

    const showTextArea = () => {
        setDisagreed(!disagreed)
    }

    return (
        <div className="mt-3">
            {(!props.AskForAgreement) && (
                <form onSubmit={cancelTicket ? handleSubmit(props.CancelTicket) : handleSubmit(props.CreateInteraction)}>
                    <div className="form-group ">
                        <textarea {...register("comentario")} className={`form-control ${errors.comentario ? 'is-invalid' : ''}`} spellCheck={false} maxLength={500} disabled={props.TypingDisabled} placeholder={props.TypingDisabled ? 'Aguarde a nossa resposta ao seu pedido...' : 'Indique aqui como o podemos ajudar...'}/>
                        <div className="invalid-feedback">{errors.comentario?.message}</div>
                    </div>
                    <div className="mt-3">
                        <button type="submit" className="btn btn-primary me-3" disabled={!isButtonEnabled} onClick={() => setCancelTicket(false)}>
                            Enviar mensagem
                        </button>
                        {(props.TicketStatus === 1 &&
                            <button type="submit" className="btn btn-secondary" onClick={() => setCancelTicket(true)} disabled={!isButtonEnabled}>
                                Cancelar pedido
                            </button>
                        )}
                    </div>
                </form>)}
            {(props.AskForAgreement) && (
                <div className="mt-3 text-center" >
                    <h4> O seu assunto ficou resolvido? </h4>
                    <button type="button" className="btn btn-primary me-3" onClick={props.DefClose}>
                        Sim
                    </button>
                    <button type="button" className="btn btn-primary btn-notSolved" onClick={showTextArea}>
                        Não
                    </button>
                    {(disagreed &&
                        <form onSubmit={handleSubmit(props.Reopen)}>
                            <div className="form-group mt-3">
                                <textarea {...register("comentario")} className={`form-control ${errors.comentario ? 'is-invalid' : ''} `} spellCheck={false} maxLength={500} placeholder='Indique aqui o que ficou por resolver...' />
                                <div className="invalid-feedback text-start">{errors.comentario?.message}</div>
                                <button type="submit" className="btn btn-secondary mt-2" disabled={!isButtonEnabled}>
                                    Reabrir pedido
                                </button>
                            </div>
                        </form>
                    )}
                </div>
            )}
        </div>
    );
};

export default RegistarInteracao;
